//This is the ADMIN view of all scheduled games and events

import React, { useEffect, useState } from 'react'
import './AdminMasterSchedule.css'
import Button from '../../shared/components/UIElements/Button'
import AdminButton from '../../shared/components/UIElements/AdminButton'
import AdminNavigation from './AdminNavigation'
import AdminSearchByVenue from './AdminSearchByVenue'
import AdminSearchByLeague from './AdminSearchByLeague'
import { NavLink, Link } from 'react-router-dom'
import ErrorModal from '../../shared/components/UIElements/ErrorModal'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import Modal from '../../shared/components/UIElements/Modal'
import { useHttpClient } from '../../shared/hooks/http-hook'

const AdminMasterSchedule = () => {
	console.log('inside AdminMasterSchedule')
	const { sendRequest, clearError } = useHttpClient()
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [itemId, setItemId] = useState('')
	const [showConfirmModal, setShowConfirmModal] = useState(false)
	const [showConflictModal, setShowConflictModal] = useState(false)
	const [cancelHasBeenClicked, setCancelHasBeenClicked] = useState()
	const [eventDeleted, setEventDeleted] = useState()
	const [allGamesAndEvents, setAllGamesAndEvents] = useState([])
	const [currentTournaments, setCurrentTournaments] = useState()

	//Let's get a list of all upcoming games and events.  allGamesAndEvents in admin-controller
	useEffect(() => {
		console.log('INSIDE USE EFFECT AdminMasterSchedule.js')
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allGamesAndEvents',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllGamesAndEvents(responseData.allItems)
				setCurrentTournaments(responseData.currentTournaments)
				//console.log('allGamesAndEvents: ' + JSON.stringify(allGamesAndEvents))

				setEventDeleted(false)
				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [eventDeleted])
	//
	//
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	//
	// =====================================================
	// MOBILE SCHEDULE HELPERS
	// =====================================================

	const formatDisplayDate = (dayOfWeek, date) => {
		if (!date) return ''

		const monthMap = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${dayOfWeek}, ${monthMap[date.substr(0, 2)]} ${date.substr(3, 2)}`
	}

	const formatDisplayTime = (time) => {
		if (!time) return 'TBD'

		const split = time.split(':')
		let hour = parseInt(split[0], 10)
		const minute = split[1]
		let suffix = 'am'

		if (hour >= 12 && hour !== 24) {
			suffix = 'pm'
		}

		if (hour === 0 || hour === 24) {
			hour = 12
		} else if (hour > 12) {
			hour = hour - 12
		}

		return `${hour}:${minute} ${suffix}`
	}

	const getWinnerName = (game) => {
		if (game.homeTeamId && game.winner === game.homeTeamId) {
			return game.homeTeamName
		}

		if (game.visitorTeamId && game.winner === game.visitorTeamId) {
			return game.visitorTeamName
		}

		return ''
	}

	const getEditLink = (game) => {
		// Events can still be edited
		if (game.eventName) {
			return `/admin/updateEvent/${game._id}`
		}

		// Completed games cannot be edited
		if (
			game.homeTeamName &&
			game.status !== 'FINAL' &&
			game.status !== 'Shootout' &&
			game.status !== 'Overtime'
		) {
			return `/admin/updateGame/${game._id}`
		}

		return null
	}

	const getResultsLink = (game) => {
		// Events do not have game results
		if (game.eventName) {
			return null
		}

		// Cannot enter results with TBD teams
		if (
			!game.homeTeamName ||
			game.homeTeamName === 'TBD' ||
			game.visitorTeamName === 'TBD'
		) {
			return null
		}

		if (game.playoff) {
			return `/admin/playoffGameResults2/${game._id}`
		}

		if (!game.playoff && !game.championship) {
			return `/admin/gameResults2/${game._id}`
		}

		return null
	}

	const getDivisionName = (game) => {
		if (game.playoff) {
			return game.playoffDivision || ''
		}

		return game.divisionName || ''
	}
	//
	//
	//
	let distinctVenues
	let distinctVenuesArray
	distinctVenuesArray = []

	if (allGamesAndEvents.length !== 0) {
		distinctVenues = [...new Set(allGamesAndEvents.map((x) => x.venueName))]
		for (let i = 0; i < distinctVenues.length; i++) {
			distinctVenuesArray.push(distinctVenues[i])
		}
	}

	//Let's strip the list down to just date, times, and venues, then we'll check to see if we
	//have any duplicates.  We dont want duplicates - that would mean a scheduling conflict.
	let dateTimeVenueArray, dateTimeVenue
	dateTimeVenueArray = []
	if (allGamesAndEvents.length !== 0) {
		for (let i = 0; i < allGamesAndEvents.length; i++) {
			dateTimeVenue =
				allGamesAndEvents[i].date +
				'   ' +
				allGamesAndEvents[i].time +
				' at ' +
				allGamesAndEvents[i].venueName
			dateTimeVenueArray.push(dateTimeVenue)
		}
	}

	//
	//
	//
	//
	let duplicateElements
	let dupes
	dupes = []
	if (dateTimeVenueArray.length !== 0 && !duplicateElements) {
		const findDuplicates = (dateTimeVenueArray) =>
			dateTimeVenueArray.filter((item, index) => {
				if (dateTimeVenueArray.indexOf(item) !== index) {
					//console.log('fucking item: ' + item)
					dupes.push(item)
				}
			})
		duplicateElements = findDuplicates(dateTimeVenueArray)
		//console.log('duplicateElements: ' + duplicateElements)
	}

	//If we do have dupes, lets turn it into a readable list so we can display it
	let dupesList
	dupesList = []
	if (dupes.length !== 0) {
		dupes.forEach((dupe) => {
			dupesList.push(<p>{dupe}</p>)
		})
	}
	//
	//
	//
	//
	const cancelConflictHandler = () => {
		setShowConflictModal(false)
		setCancelHasBeenClicked(true)
	}
	//
	//
	//
	//
	//
	//
	let dateBlock
	dateBlock = []
	if (!isLoading && allGamesAndEvents.length === 0) {
		return (
			<React.Fragment>
				<div className='AdminLeagues'>
					<AdminNavigation />
					<AdminSearchByVenue />
					<AdminSearchByLeague />
					{/* <SchedulesHomeNavigation /> */}
					{/* <SearchByLeagueOrTeam /> */}
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>

				<div className='container-fluid masterScheduleDesktopButtons'>
					<div className='row'>
						<div className='col-sm'></div>
						<div className='col-sm' align='center'>
							<tr style={{ backgroundColor: '#e0e0e0' }}>
								<td className='adminVenueTableData'>
									<AdminButton
										to={`/games/new`}
										exact
										style={{ color: 'white', textDecoration: 'none' }}
									>
										Add new Game
									</AdminButton>
								</td>
								{/* <td className='adminVenueTableData'>
									<AdminButton
										to={`/admin/events/new`}
										exact
										style={{ color: 'white', textDecoration: 'none' }}
									>
										Add new Event
									</AdminButton>
								</td> */}
							</tr>
						</div>
						<div className='col-sm'></div>
					</div>
				</div>
			</React.Fragment>
		)
	}
	if (
		!isLoading &&
		allGamesAndEvents.length !== 0 &&
		currentTournaments.length !== 0 &&
		distinctVenuesArray
	) {
		distinctVenuesArray.forEach((venue) => {
			dateBlock.push(
				<div className='AdminLeagues masterSchedulePage'>
					<AdminNavigation />

					<div className='masterScheduleSearches'>
						<AdminSearchByVenue />
						<AdminSearchByLeague />
					</div>

					{/* DESKTOP / TABLET HEADING */}
					<div className='masterScheduleDesktopHeading'>
						<h1>{venue}</h1>
					</div>

					{/* MOBILE HEADING */}
					<div className='masterScheduleMobileHeading'>
						<h1>Master Schedule</h1>
						<h2>{venue}</h2>
					</div>

					<div className='masterScheduleNote'>
						<div className='masterScheduleNoteIcon'>i</div>

						<div className='masterScheduleNoteText'>
							<strong>NOTE</strong>

							<p>
								You cannot enter results for a game where either team is still
								'TBD'. Completed games cannot be edited except results. If
								needed, delete the game and re-do it.
							</p>
						</div>
					</div>
					{/* =====================================================
	MOBILE MASTER SCHEDULE CARDS
===================================================== */}

					<div className='mobileMasterScheduleCards'>
						{allGamesAndEvents.map((game, key) => {
							if (game.venueName !== venue) {
								return null
							}

							const editLink = getEditLink(game)
							const resultsLink = getResultsLink(game)
							const winnerName = getWinnerName(game)
							const division = getDivisionName(game)
							const isEvent = !!game.eventName

							return (
								<div className='mobileMasterScheduleCard' key={game._id}>
									{/* DATE / TIME / DIVISION */}
									<div className='mobileMasterScheduleDateCol'>
										<div className='mobileMasterScheduleDate'>
											{formatDisplayDate(game.dayOfWeek, game.date)}
										</div>

										<div className='mobileMasterScheduleTime'>
											{formatDisplayTime(game.time)}
										</div>

										<div
											className={
												isEvent
													? 'mobileMasterScheduleBadge mobileMasterScheduleEventBadge'
													: 'mobileMasterScheduleBadge'
											}
										>
											{isEvent ? 'EVENT' : division}
										</div>
									</div>

									{/* GAME / EVENT INFORMATION */}
									<div className='mobileMasterScheduleMainCol'>
										{isEvent ? (
											<>
												<div className='mobileMasterScheduleMatchup'>
													{game.eventName}
												</div>

												{game.leagueName && (
													<div className='mobileMasterScheduleMeta'>
														<strong>Tournament:</strong> {game.leagueName}
													</div>
												)}
											</>
										) : (
											<>
												<div className='mobileMasterScheduleMatchup'>
													{game.visitorTeamSeed > 0 &&
														`(${game.visitorTeamSeed}) `}

													{game.visitorTeamName}

													{' @ '}

													{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}

													{game.homeTeamName}
												</div>

												{currentTournaments.length > 1 && (
													<div className='mobileMasterScheduleMeta'>
														<strong>Tournament:</strong> {game.leagueName}
													</div>
												)}

												{game.description && (
													<div className='mobileMasterScheduleDescription'>
														({game.description})
													</div>
												)}

												<div className='mobileMasterScheduleMeta'>
													<strong>Score:</strong> {game.score || '—'}
												</div>

												<div className='mobileMasterScheduleMeta'>
													<strong>Winner:</strong> {winnerName || '—'}
												</div>
											</>
										)}
									</div>

									{/* ACTIONS */}
									<div className='mobileMasterScheduleActions'>
										{editLink && (
											<NavLink
												className='mobileMasterScheduleAction'
												to={editLink}
												exact
											>
												Edit
											</NavLink>
										)}

										{resultsLink && (
											<NavLink
												className='mobileMasterScheduleAction mobileMasterScheduleActionResults'
												to={resultsLink}
												exact
											>
												Results
											</NavLink>
										)}

										<button
											className='mobileMasterScheduleAction mobileMasterScheduleActionDelete'
											id={key}
											onClick={(e) => showDeleteWarningHandler(e)}
										>
											Delete
										</button>
									</div>
								</div>
							)
						})}

						<div className='mobileMasterScheduleButtons'>
							<AdminButton
								to={`/games/new`}
								exact
								style={{
									color: 'white',
									textDecoration: 'none',
								}}
							>
								+ &nbsp; Add New Game
							</AdminButton>

							{/* <AdminButton
								to={`/admin/events/new`}
								exact
								style={{
									color: 'white',
									textDecoration: 'none',
								}}
							>
								+ &nbsp; Add New Event
							</AdminButton> */}
						</div>
					</div>
					<table id='masterScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time</th>
								{/* <th>Time</th> */}
								{currentTournaments.length > 1 && <th>Tournament</th>}
								<th>Division</th>
								{/* <th>Status</th> */}
								<th>Score</th>
								{/* <th></th> */}
								<th>Visitor/Home</th>
								{/* <th>Playoff/Championship?</th> */}
								{/* <th></th> */}
								{/* <th>Venue</th> */}
								<th></th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{allGamesAndEvents.map((game, key) => {
								if (game.venueName === venue) {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{/* {game.date} */}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												{/* </td>
									<td> */}
												<br></br>
												{' @ '}
												<br></br>
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am'}
											</td>
											{currentTournaments.length > 1 && (
												<td>
													{(game.leagueName && game.leagueName) ||
														game.eventName}
												</td>
											)}
											{!game.playoff && (
												<td>{game.leagueName && game.divisionName}</td>
											)}
											{game.playoff && <td>{game.playoffDivision}</td>}
											{/* <td>{game.status || 'TBP'}</td> */}
											<td>{game.score}</td>
											{/* <td></td> */}
											{game.visitorTeamName && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamName && game.visitorTeamName}
													<br></br>
													{' @ '}
													<br></br>
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamName && game.homeTeamName}
													{game.playoff && <br></br>}
													<div style={{ color: 'red', fontWeight: 'bold' }}>
														{game.playoff && game.description}
													</div>
												</td>
											)}
											{game.eventName && (
												<td
													style={{
														fontWeight: 'bold',
														backgroundColor: 'pink',
													}}
												>
													{game.eventName}
												</td>
											)}
											<td>
												{game.homeTeamName &&
													game.status !== 'FINAL' &&
													game.status !== 'Shootout' &&
													game.status !== 'Overtime' &&
													((game.homeTeamName && (
														<NavLink
															className='navlinks'
															to={`/admin/updateGame/${game._id}`}
															exact
														>
															Edit
														</NavLink>
													)) || (
														<NavLink
															className='navlinks'
															to={`/admin/updateEvent/${game._id}`}
															exact
														>
															Edit
														</NavLink>
													))}
												{!game.homeTeamName && (
													<NavLink
														className='navlinks'
														to={`/admin/updateEvent/${game._id}`}
														exact
													>
														Edit
													</NavLink>
												)}
											</td>
											<td>
												{game.playoff &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/playoffGameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
												{!game.playoff &&
													!game.championship &&
													game.homeTeamName &&
													game.homeTeamName !== 'TBD' &&
													game.visitorTeamName !== 'TBD' && (
														<NavLink
															className='navlinks'
															to={`/admin/gameResults2/${game._id}`}
															exact
														>
															Results
														</NavLink>
													)}
											</td>
											<td>
												<button
													className='buttonButton'
													style={{ color: 'red' }}
													id={key}
													onClick={(e) => showDeleteWarningHandler(e)}
												>
													DELETE
												</button>
											</td>
											<td>
												{!game.eventName && (
													<NavLink
														className='navlinks'
														to={`/admin/scoresheet/${game._id}`}
														exact
													>
														SCORESHEET
													</NavLink>
												)}
											</td>
											<td></td>
										</tr>
									)
								}
							})}
							{/* <tr style={{ backgroundColor: '#e0e0e0' }}>
								<td>
									<AdminButton
										to={`/games/new`}
										exact
										style={{ color: 'white', textDecoration: 'none' }}
									>
										Add new Game
									</AdminButton>
								</td>
								<td></td>
								<td>
									<AdminButton
										to={`/admin/events/new`}
										exact
										style={{ color: 'white', textDecoration: 'none' }}
									>
										Add new Event
									</AdminButton>
								</td>
							</tr> */}
						</tbody>
					</table>
					<div className='container-fluid masterScheduleDesktopButtons'>
						<div className='row'>
							<div className='col-sm' align='center'>
								<AdminButton
									to={`/games/new`}
									exact
									style={{ color: 'white', textDecoration: 'none' }}
								>
									Add new Game
								</AdminButton>
								{/* <AdminButton
									to={`/admin/events/new`}
									exact
									style={{ color: 'white', textDecoration: 'none' }}
								>
									Add new Event
								</AdminButton> */}
							</div>
						</div>
					</div>
				</div>,
			)
		})
	}

	//
	//
	//
	//
	const showDeleteWarningHandler = (e) => {
		//console.log('e: ' + e.target.id)
		const value = e.target.id
		console.log(
			'Game you wish to delete: ' + JSON.stringify(allGamesAndEvents[value]),
		)
		setItemId(allGamesAndEvents[value]._id)
		setShowConfirmModal(true)
	}
	//
	//
	//
	//
	const cancelDeleteHandler = () => {
		setShowConfirmModal(false)
	}
	//
	//
	//
	//
	const confirmDeleteHandler = async () => {
		setShowConfirmModal(false)
		//console.log('itemId: ' + itemId)
		try {
			await sendRequest(
				`${process.env.REACT_APP_BACKEND_URL}/admin/${itemId}/removeEvent`, //can be event OR game
				'DELETE',
			)
		} catch (err) {
			console.log(err)
		}
		setEventDeleted(true)
		console.log('DELETING...')
	}

	return (
		<React.Fragment>
			<ErrorModal error={error} onClear={errorHandler} />
			{isLoading && (
				<div className='center'>
					<LoadingSpinner />
				</div>
			)}
			<Modal
				show={showConfirmModal}
				onCancel={cancelDeleteHandler}
				header='Are you sure?'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<p className='modalText'>
							Are you sure you wish to delete this item?
						</p>
						<br></br>
						<button
							className='cancelDeleteButtons buttonButton'
							inverse
							style={{ float: 'right' }}
							onClick={cancelDeleteHandler}
						>
							CANCEL
						</button>
						<button
							className='cancelDeleteButtons buttonButton'
							style={{ color: 'red' }}
							danger
							onClick={confirmDeleteHandler}
						>
							DELETE GAME OR EVENT
						</button>
					</React.Fragment>
				}
			></Modal>
			<Modal
				//show={showConflictModal}
				show={dupes.length > 0 && !cancelHasBeenClicked}
				onCancel={cancelConflictHandler}
				header='SCHEDULING CONFLICT!!'
				footerClass='place-item__modal-actions'
				footer={
					<React.Fragment>
						<h3>
							We have multiple items scheduled for the same date, time, and
							place!
						</h3>
						<p>{dupesList}</p>
						<br></br>
						<button
							className='cancelDeleteButtons'
							inverse
							style={{ float: 'right' }}
							onClick={cancelConflictHandler}
						>
							OK
						</button>
					</React.Fragment>
				}
			></Modal>
			{/* <AdminSearchByVenue />
			<AdminSearchByLeague /> */}
			{dateBlock && <div style={{ overflowX: 'auto' }}>{dateBlock}</div>}
		</React.Fragment>
	)
}

export default AdminMasterSchedule
